import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { ProductDetailDescriptionView } from '@grandvisionhq/fun-products';
import { useIntl } from '@grandvisionhq/state';
import ProductDetailSpecification from '../../../../ProductDetailSpecification/ProductDetailSpecification.js';
import { getSolutionsFeatures } from '../../utils/get-solutions-features.js';
import SolutionsFeatures from '../SolutionsFeatures/SolutionsFeatures.js';
import SolutionsProductDetails from '../SolutionsProductDetails/SolutionsProductDetails.js';

const Description = ({ variant , specificationVariant , specificationConfiguration  })=>{
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            description: variant.description,
            header: variant.header || getLabel('products.solutions.header.header'),
            title: getLabel('products.solutions.header.details') || 'Product Details',
            targetUsers: variant.targetUsers,
            convenience: variant.convenience,
            keyInstructions: variant.keyInstructions,
            disclaimer: getLabel('products.solutions.features.disclaimer')
        })
    , [
        getLabel,
        variant
    ]);
    const { productFeatures , solutionsFeatures  } = React__default.useMemo(()=>getSolutionsFeatures(variant, getLabel)
    , [
        getLabel,
        variant
    ]);
    return /*#__PURE__*/ React__default.createElement(ProductDetailDescriptionView, {
        title: labels.header,
        description: labels.description
    }, /*#__PURE__*/ React__default.createElement(SolutionsFeatures, swcHelpers.extends({}, solutionsFeatures)), /*#__PURE__*/ React__default.createElement(SolutionsProductDetails, {
        targetUsers: labels.targetUsers,
        convenience: labels.convenience,
        keyInstructions: labels.keyInstructions,
        headerTitle: labels.title
    }), /*#__PURE__*/ React__default.createElement(ProductDetailSpecification, {
        configuration: specificationConfiguration || productFeatures,
        variant: specificationVariant
    }), labels.disclaimer);
};
var Description$1 = Description;

export { Description$1 as default };
//# sourceMappingURL=Description.js.map
